// Components
import { Root as RootComponent } from "./Root";
import { Actions } from "./Actions";
import { ActionGroup } from "./ActionGroup";

// Types
import type {
  TitleRootProps,
  TitleActionsProps,
  TitleActionGroupProps
} from "./Title.types";

// Create the Title namespace for internal use and stories
const Title = Object.assign(RootComponent, {
  Root: RootComponent,
  Actions,
  ActionGroup
});

// Export the Title namespace
export { Title };

// Export components individually
export { RootComponent, Actions, ActionGroup };

// Export types
export type { TitleRootProps, TitleActionsProps, TitleActionGroupProps };

// Default export for internal usage
export default Title;
